export default {
    getSelectedVersion: state => {
        return state.selectedVersion;
    }
}
